import { v4 as uuidv4 } from "uuid";
import { ApiHeaders } from "./headers.types";
import { REGEXP } from "../constants/regex.constants";
import { useLocation } from "react-router-dom";
import { DEFAULT_SCREEN_ID } from "../config/constants";
import { VITE_AUTHORIZATION_TOKEN } from "../config/env";
import { useStore } from "@/store/store";

const useRequestHeaders = (serviceType?: string) => {
  const location = useLocation();
  const accessToken = useStore((state) => state?.auth?.state?.accessToken);

  const generateScreenId = (location: string) => {
    return (
      location
        ?.replace(REGEXP.screenIdExclusion, "_")
        .replace(/^_+|_+$/g, "") || DEFAULT_SCREEN_ID
    );
  };
  const generateHeaders = (): ApiHeaders => ({
    "request-id": uuidv4(),
    "channel-id": "GENAI", // TODO: Confirm channel-id
    "app-version": "1.0.0",
    "ref-id": "1234", //TODO: Get user id
    "session-id": uuidv4(),
    "screen-id": generateScreenId(location?.pathname),
    "correlation-id": crypto.randomUUID(),
    location: "19.076090, 72.877426",
    "device-details": "rhkvjbdlkexmhjwz",
    "device-type": "Mobile",
    "device-id": "LT092321",
    "device-version": "0.0.1",
    "audit-service-type": serviceType ?? "",
    authorization: `Bearer ${accessToken || VITE_AUTHORIZATION_TOKEN}`,
    "auth-token": accessToken,
    "x-service-token": "",
    "device-os": "chrome",
    "device-family": "Apple",
    "device-name": "Iphone4s",
    "Content-Type": "application/json",
    "event-id": uuidv4(),
    "event-version": uuidv4(),
  });

  return { generateHeaders };
};

export default useRequestHeaders;
